<template>
  <PublicHeader />
</template>

<script>
import PublicHeader from '@/modules/core/components/Header/PublicHeader';

export default {
  name: 'CoreModule',
  components: {
    PublicHeader
  }
}
</script>
